import * as React from 'react'

import { AcrobatIcon } from '../icons/AcrobatIcon'
import { AttachmentIcon } from '../icons/AttachmentIcon'
import { ExcelIcon } from '../icons/ExcelIcon'
import { PhotoIcon } from '../icons/PhotoIcon'
import { PowerpointIcon } from '../icons/PowerpointIcon'
import { WordIcon } from '../icons/WordIcon'
import { FileKind } from './fileKind'

interface FileTypeIconProps {
  kind: FileKind
}

const MUTED_CLASS = 'tw:text-md3-on-surface-variant'

export default function FileTypeIcon({ kind }: FileTypeIconProps) {
  switch (kind) {
    case 'pdf':
      return <AcrobatIcon size="md" />
    case 'word':
      return <WordIcon size="md" />
    case 'excel':
      return <ExcelIcon size="md" />
    case 'ppt':
      return <PowerpointIcon size="md" />
    case 'image':
    case 'video':
      return <PhotoIcon size="md" className={MUTED_CLASS} />
    default:
      return <AttachmentIcon size="md" className={MUTED_CLASS} />
  }
}
